import { Container } from '@components/layout/grid'
import { Markdown } from '@components/markdown'
import { ActionButton } from '@contentful-components/action-button'
import type { SimpleHeaderSectionFragment } from '@graphql/fragments/SimpleHeaderSectionFragment.graphql'
import variables, { type Variable } from '@styles/variables'
import type { FunctionComponent } from 'react'

import styles from './simple-header-section.module.scss'

/**
 * Section that displays a heading, text.
 */

export const SimpleHeaderSection: FunctionComponent<Props> = ({
    heading = '',
    headingColor = 'white',
    subtitle,
    subtitleColor = 'white',
    anchorId = '',
    backgroundColor = 'blackV2',
    button,
    spacingTop = 'gapXXLarge',
    spacingBottom = 'gapXXLarge',
}) => {
    return (
        <div
            style={{
                backgroundColor: variables[backgroundColor as Variable],
                paddingTop: variables[spacingTop as Variable],
                paddingBottom: variables[spacingBottom as Variable],
            }}
            className={styles.ctaSection}
        >
            <Container id={anchorId}>
                <div>
                    {!!heading && (
                        <div className={styles.heading}>
                            <Markdown
                                tag='h2'
                                typeStyle={{
                                    _: 'heading-md',
                                    md: 'heading-sm',
                                }}
                                markdown={heading.toUpperCase()}
                                color={headingColor}
                            />
                        </div>
                    )}
                    {!!subtitle && (
                        <div className={styles.subtitle}>
                            <Markdown
                                tag='p'
                                typeStyle={{ _: 'body-lg' }}
                                markdown={subtitle}
                                color={subtitleColor}
                            />
                        </div>
                    )}
                    {!!button && (
                        <ActionButton preset={button?.preset} {...button} />
                    )}
                </div>
            </Container>
        </div>
    )
}

export default SimpleHeaderSection

type Props = Omit<SimpleHeaderSectionFragment, 'sys' | 'type'> & {
    index?: number
}
